import { useEffect, Fragment, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { MainLoader } from '../UI/Loader/Loaders';
import Navbar from '../layout/Navbar';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { useActions } from '../../hooks/useActions';

interface PrivateRouteProps {
  component: React.ElementType;
  access?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  access,
  ...rest
}) => {
  const location = useLocation();
  const { userLoading, url, isAuthenticated, user } = useTypedSelector(
    (state) => state.auth
  );
  const { loadUser, setUrl } = useActions();

  const checkAccess = (access: string[] | undefined) => {
    if (!access) return true;
    return access.includes(user.role);
  };

  useEffect(() => {
    if (!url) {
      setUrl(`${location.pathname}${location.search}`);
    }
  }, [url, location, setUrl]);

  useEffect(() => {
    if (!user.email) {
      loadUser();
    }
  }, [loadUser, user.email]);

  if (userLoading) return <MainLoader />;
  if (!isAuthenticated) return <Navigate to='/' />;
  if (!checkAccess(access)) return <Navigate to='/dashboard/' />;

  return (
    <Fragment>
      <Navbar />
      <div className='main-container'>
        <Suspense fallback={<MainLoader />}>
          <Component {...rest} />
        </Suspense>
      </div>
    </Fragment>
  );
};

export default PrivateRoute;
